<template>
  <div class="board-preview">
    <preview-board-header v-if="!hideHeader" :board="board"></preview-board-header>
    <div class="wrapper" ref="wrapper">
      <div v-if="_.isEmpty(layout)" class="empty">暂无看板图表数据</div>
      <div v-else class="edit-content">
        <storyline
          v-if="!_.isEmpty(board.storyline)"
          :storyline="board.storyline"
          :charts="board.charts"
          :theme="board.theme"
          :current-node-id="currentNodeId"
          @goChart="goChart"
          from="preview"
        ></storyline>
        <div
          class="content"
          ref="content"
          id="content"
          v-ps
          @scroll="onScrollThrottle"
          :class="'board-' + board.theme + '-content'"
        >
          <grid-layout
            ref="gridlayout"
            :layout.sync="layout"
            :row-height="40"
            :col-num="18"
            :is-draggable="false"
            :is-resizable="false"
            :vertical-compact="false"
            :use-css-transforms="false"
            @layout-ready="layoutMounted = true"
          >
            <grid-item
              :key="item.i"
              v-for="item in layout"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
            >
              <div ref="component" class="component-wrapper">
                <div
                  v-if="item.itemType === 'chart'"
                  class="figure"
                  ref="figure"
                  :class="'board-theme-' + board.theme"
                >
                  <div class="setting">
                    <span v-if="item.showName">
                      {{ item.name }}
                    </span>
                    <el-tooltip
                      v-if="item.desc"
                      class="item"
                      effect="dark"
                      :content="item.desc"
                      placement="right-start"
                    >
                      <i class="el-icon-info pointer" style="margin: 0 4px"></i>
                    </el-tooltip>
                    <svg-icon
                      icon-class="board_filter"
                      class="pointer"
                      @click.native="clickBtn('filter', item)"
                    ></svg-icon>
                    <span style="float: right;" class="more-setting">
                      <svg-icon
                        icon-class="board_refresh"
                        class="refresh"
                        :class="item.active ? 'button-active' : ''"
                        @click.native="clickBtn('refresh', item)"
                      ></svg-icon>
                      <el-tooltip class="item" effect="dark" content="全屏" placement="bottom">
                        <svg-icon
                          icon-class="board_full"
                          class="full"
                          @click.native="clickBtn('full', item)"
                        ></svg-icon>
                      </el-tooltip>
                      <dropdown-menu
                        v-if="exportMap[item.chartId].length"
                        :menu-list="exportMap[item.chartId]"
                        @click="handleCommand($event, item)"
                        placement="bottom-end"
                      >
                        <span class="pointer">
                          <svg-icon icon-class="board_more" class="pointer"></svg-icon>
                        </span>
                      </dropdown-menu>
                    </span>
                  </div>
                  <chart-item
                    :chart="item"
                    :boardId="board.id"
                    :theme="board.theme"
                    :hideHeader="hideHeader"
                    :app-id="board.appId"
                    ref="image"
                    class="image"
                    id="image"
                    :class="'board-theme-' + board.theme"
                  ></chart-item>
                </div>
                <div
                  v-else-if="item.itemType === 'query'"
                  class="query"
                  :class="'board-theme-' + board.theme"
                >
                  <div class="setting">
                    <div class="name" v-if="item.showName">
                      {{ item.name }}
                    </div>
                    <div class="query-wrapper">
                      <div class="query-info" v-ps>
                        <div v-for="condition in item.conditions" :key="condition.id">
                          <condition
                            ref="condition"
                            :condition="condition"
                            :controlOptionsMap="controlOptionsMap"
                            :charts="board.charts"
                            :var-value-map="varValueMap"
                            @getVarValueMap="getVarValueMap('boardEdit', item.conditions)"
                          ></condition>
                        </div>
                        <base-button
                          type="primary"
                          @click="query('boardEdit', item.conditions)"
                          style="margin-left: 3px"
                        >
                          查询
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="item.itemType === 'rich'"
                  class="rich"
                  :class="'board-theme-' + board.theme"
                  :style="
                    item.backgroundColor
                      ? 'background-color:' + item.backgroundColor + ' !important'
                      : ''
                  "
                >
                  <div class="setting">
                    <div class="name" v-if="item.showName">
                      {{ item.name }}
                    </div>
                    <div v-if="item.content" class="rich-info" v-ps>
                      <span class="rich-field" v-html="item.content"></span>
                    </div>
                    <div v-else class="empty">
                      <svg-icon icon-class="board_rich" class="empty-icon"></svg-icon>
                      <div class="empty-title">富文本配置异常</div>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="item.itemType === 'view'"
                  class="view"
                  :class="'board-theme-' + board.theme"
                  :style="
                    item.backgroundColor
                      ? 'background-color:' + item.backgroundColor + ' !important'
                      : ''
                  "
                >
                  <div class="setting">
                    <div class="name" v-if="item.showName">
                      {{ item.name }}
                    </div>
                    <div class="view-info" v-if="item.sheetId && item.viewId">
                      <worksheet
                        :board-view="item"
                        :key="item.sheetId + item.viewId"
                        :theme="'board-theme-' + board.theme"
                      ></worksheet>
                    </div>
                    <div v-else class="empty">
                      <svg-icon icon-class="board_view" class="empty-icon"></svg-icon>
                      <div class="empty-title">视图配置异常</div>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="item.itemType === 'image'"
                  class="image"
                  :class="'board-theme-' + board.theme"
                  :style="
                    item.backgroundColor
                      ? 'background-color:' + item.backgroundColor + ' !important'
                      : ''
                  "
                >
                  <div class="setting">
                    <span style="font-weight: bolder;position: absolute;left:4px">
                      {{ item.showName ? item.name : "" }}
                    </span>
                    <div
                      class="image-info"
                      v-if="item.url"
                      :style="{ background: `url(${item.url})` }"
                    >
                      <div class="no-drag" @click="gotoImageLink(item.link)"></div>
                    </div>
                    <div v-else class="empty"></div>
                  </div>
                </div>
              </div>
            </grid-item>
          </grid-layout>
        </div>
      </div>
    </div>
    <chart-filter
      ref="chartFilter"
      @submit="submitChartFilter"
      :dialog-visible.sync="chartFilterVisible"
      :search-sheet="{ sheetId: sheet.sheetId, controls: sheet.controls }"
      :condition-list="conditionList"
      :pre-condition-list="preConditionList"
      @close="close"
    ></chart-filter>
  </div>
</template>

<script>
import PreviewBoardHeader from "@/views/Backend/Admin/Statistics/PreviewBoardHeader"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import ChartFilter from "@/components/UIComponents/ChartFilter"
import ExportChart from "@/views/Backend/Admin/Layout/mixin/ExportChart"
import * as boardApi from "@/api/appManage/statistics"
import { getAvailableSheets, getSheet } from "@/api/sheet/sheet"
import { exportCrossTableExcel, exportExcel } from "@/views/Backend/Admin/Layout/mixin/export2Excel"
import ChartItem from "./chartEdit/ChartItem.vue"
import BaseButton from "@/components/UIComponents/Button"
import Condition from "@/views/Backend/Admin/Statistics/Condition"
import QueryMixin from "@/views/Backend/Admin/Statistics/QueryMixin"
import { GridLayout, GridItem } from "vue-grid-layout"
import html2Canvas from "html2canvas"
import { loadingService } from "@/utils/ui"
import Storyline from "@/views/Backend/Admin/Statistics/storyline"
import Worksheet from "@/views/Front/Sheet/View"
export default {
  name: "BoardPreview",
  components: {
    Worksheet,
    Storyline,
    PreviewBoardHeader,
    DropdownMenu,
    ChartFilter,
    GridLayout,
    GridItem,
    ChartItem,
    BaseButton,
    Condition
  },
  props: {
    hideHeader: {
      type: Boolean,
      default: false
    },
    manualRefresh: Boolean, // 手动刷新模式
    from: String // share 看板分享
  },
  // 视图
  provide() {
    return {
      app: {}
    }
  },
  data() {
    return {
      board: {},
      sheet: {},
      curFigureId: "",
      chartFilterVisible: false,
      conditionList: [],
      preConditionList: [],
      selectChart: {
        chart: {},
        index: null
      },
      sheets: [],
      layout: []
    }
  },
  mixins: [ExportChart, QueryMixin],
  computed: {
    controlOptionsMap() {
      let result = {}
      this.sheets.forEach(sheet => {
        sheet.controls.forEach(control => {
          if (control._type === "option") {
            result[control._cid] = control.options
          } else if (control._type === "field" && control._refControl?._type === "option") {
            result[control._cid] = control._refControl?.options
          }
        })
      })
      return result
    },
    exportMap() {
      let result = {}
      this.board.charts?.forEach(chart => {
        result[chart.chartId] = this.getExportOptions(chart)
      })
      return result
    }
  },
  mounted() {
    if (!this.manualRefresh) this.refresh()
  },
  methods: {
    getExportOptions(chart) {
      let result = []
      if (!this._.keys(chart).includes("canSeeAll") || chart.canSeeAll === null) {
        if (this.board.canExportImage) result.push({ command: "exportImage", title: "导出图片" })
        if (this.board.canExportExcel)
          result.push({
            command: "exportExcel",
            title: "导出数据"
          })
      } else {
        if (chart.canExportImage) result.push({ command: "exportImage", title: "导出图片" })
        if (chart.canExportExcel)
          result.push({
            command: "exportExcel",
            title: "导出数据"
          })
      }
      return result
    },
    async refresh(boardId) {
      if (boardId || !localStorage.getItem("board")) {
        await boardApi.getDashboard(boardId || this.$route.query.id).then(board => {
          this.$emit("change", this._.cloneDeep(board))
          this.board = board
          this.getLayout()
          this.queryCharts()
          this.getMostTop()
        })
      } else {
        let board = JSON.parse(localStorage.getItem("board"))
        this.$emit("change", this._.cloneDeep(this.board))
        this.board = board
        this.getLayout()
        this.queryCharts()
        this.getMostTop()
      }
      getAvailableSheets({ appId: this.board.appId }).then(sheetDefs => {
        this.sheets = sheetDefs.flatMap(app => app.sheets)
      })
    },
    clickBtn(btn, layoutItem) {
      let ref = this.$refs.image.find(i => i.chartData?.chartId === layoutItem.chartId)
      let item = ref._data?.chartData
      let index = this._.findIndex(this.board.charts, ["chartId", item.chartId])
      switch (btn) {
        case "filter":
          this.selectChart = {
            chart: item,
            index: index
          }
          this.chartFilterVisible = true
          this.conditionList = item.filters
          this.preConditionList = [item.queryFilters]
          this.curFigureId = item.chartId
          getSheet(item.sheetId).then(res => {
            this.sheet = res
          })
          break
        case "refresh": {
          item.active = true
          setTimeout(() => (item.active = false), 1000)
          if (["indicator", "cross-table"].includes(item.type)) {
            this.$refs.image[index].init(item)
          } else if (item.type === "map") {
            let hashMap = this.$refs.image[index].hashMap
            let key = this._.max(Array.from(hashMap.keys()))
            this.$refs.image[index].initMap(key, hashMap.get(key))
          } else {
            let drawInfo = this.$refs.image[index].drawInfo
            let drawIndex = drawInfo.length - 1
            this.$refs.image[index].changeChart(drawInfo[drawIndex], drawIndex)
          }
          break
        }
        case "full":
          this.from === "share"
            ? this.$router.push({
                name: "board-share-full",
                query: {
                  boardId: this.board.id,
                  chartId: item.chartId,
                  hideHeader: JSON.stringify(this.hideHeader),
                  preConditions: JSON.stringify(item.queryFilters ? item.queryFilters : []),
                  resConditions: JSON.stringify(item.resFilters ? item.resFilters[0] : [])
                }
              })
            : this.$router.push({
                name: "board-full",
                query: {
                  boardId: this.board.id,
                  chartId: item.chartId,
                  hideHeader: JSON.stringify(this.hideHeader),
                  preConditions: JSON.stringify(item.queryFilters ? item.queryFilters : []),
                  resConditions: JSON.stringify(item.resFilters ? item.resFilters[0] : [])
                }
              })
          break
      }
    },
    handleCommand(command, figure) {
      let index = this._.findIndex(this.board.charts, ["chartId", figure.i])
      switch (command) {
        case "exportImage": {
          let picInfo = ""
          if (!["cross-table", "indicator"].includes(figure.type)) {
            picInfo = this.$refs.image[index].getDataURL()
            this.exportImage(picInfo, figure.name)
          } else if (figure.type === "indicator") {
            let loadingInstance = loadingService()
            setTimeout(() => {
              let ref = this.$refs.image.find(i => i.chartData?.chartId === figure.chartId).$el
              html2Canvas(ref)
                .then(canvas => {
                  picInfo = canvas.toDataURL("image/png")
                  this.exportImage(picInfo, figure.name)
                })
                .finally(() => loadingInstance.close())
            }, 100)
          } else {
            let loadingInstance = loadingService()
            setTimeout(() => {
              let ref = this.$refs.image.find(i => i.chartData?.chartId === figure.chartId).$refs
                .pivotTable
              ref.dealExportImage("before").then(() => {
                setTimeout(() => {
                  let dom = this.$refs.image.find(i => i.chartData?.chartId === figure.chartId)
                    .$refs.pivotTable.$refs.xTable.$el
                  html2Canvas(dom)
                    .then(canvas => {
                      picInfo = canvas.toDataURL("image/png")
                      this.exportImage(picInfo, figure.name)
                    })
                    .finally(() => {
                      ref.dealExportImage("after").then(() => loadingInstance.close())
                    })
                }, 100)
              })
            }, 100)
          }
          break
        }
        case "exportExcel":
          if (figure.type !== "cross-table") {
            require.ensure([], () => {
              let ref = this.$refs.image.find(i => i.chartData?.chartId === figure.chartId)
              let data = ref._data?.axisData || []
              let drillId = ref._data?.drillDownId
              let drillList = this.getDrillList(figure)
              let drill = drillList.find(drill => drill.id === drillId)
              let all = (drillId ? [drill] : figure.xAxisList).concat(figure.yAxisList)
              let allIds = all.map(axis => axis.id)
              let yIds = figure.yAxisList.map(yaxis => yaxis.id)
              const tHeader = all.map(axis => axis.name)
              let tableData = data.map(item => {
                let result = []
                allIds.forEach(id => {
                  if (yIds.includes(id)) {
                    result.push(Number(item[id]))
                  } else {
                    result.push(item[id])
                  }
                })
                return result
              })
              exportExcel(tHeader, tableData, figure.name)
            })
          } else {
            let ref = this.$refs.image.find(i => i.chartData?.chartId === figure.chartId).$refs
              .pivotTable
            let loadingInstance = loadingService()
            ref.dealExportExcel("before").then(() => {
              setTimeout(() => {
                let data = this.$refs.image.find(i => i.chartData?.chartId === figure.chartId).$el
                exportCrossTableExcel(data, figure.name)
                setTimeout(() => {
                  ref.dealExportExcel("after").then(() => loadingInstance.close())
                })
              })
            })
          }
          break
      }
    },
    gotoImageLink(link) {
      if (link == "") return
      else window.open(link, "_blank")
    },
    getDrillList(figure) {
      let result = []
      figure.xAxisList.forEach(xAxis => {
        if (xAxis.drillDownList?.length) {
          result.push(...xAxis.drillDownList)
        }
      })
      return result
    },
    submitChartFilter(conditions, preConditions) {
      this.board.charts = this.board.charts.map(chart => {
        if (chart.chartId === this.curFigureId) {
          chart.queryFilters = preConditions.length === 0 ? [] : preConditions[0]
          chart.filters = conditions
          this.$refs.image[this.selectChart.index].init(chart)
        }
        return chart
      })
      this.chartFilterVisible = false
      this.$message.success("操作成功")
    },
    close() {
      this.chartFilterVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.board-preview {
  width: 100%;
  height: 100%;
  .wrapper {
    box-sizing: border-box;
    padding: 52px 0 0 0;
    height: 100%;
    width: 100%;
    .empty {
      position: absolute;
      margin: auto;
      width: 100%;
      top: calc(50% - 23px);
      text-align: center;
      .svg-icon,
      i {
        font-size: 160px;
        color: #fff;
      }
      .empty-icon {
        height: 28px;
        width: 28px;
      }
      .empty-title {
        font-size: 12px;
        font-weight: 400;
        color: #c0c4cc;
        line-height: 17px;
      }
    }
    .edit-content {
      background-color: #f5f7fa;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      .content {
        flex: 1;
        .vue-grid-layout {
          margin-bottom: 50px;
          .vue-grid-item {
            box-sizing: border-box;
            touch-action: none;
            .component-wrapper {
              width: 100%;
              height: 100%;
              .figure {
                height: 100%;
                width: 100%;
                border-radius: 4px;
                display: flex;
                flex-flow: column;
                cursor: move;
                &:hover {
                  .more-setting {
                    display: block !important;
                  }
                }
                .setting {
                  font-weight: bold;
                  font-size: 14px;
                  text-align: left;
                  margin: 6px 10px 0 10px;
                  height: 19.2px;
                  display: inline-table;
                  .more-setting {
                    display: none;
                    .refresh {
                      cursor: pointer;
                      margin-right: 6px;
                    }
                    .button-active {
                      animation: rotate 1s infinite;
                      -webkit-animation: rotate 1s infinite;
                    }
                    @keyframes rotate {
                      0% {
                        transform: rotate(0deg);
                        -ms-transform: rotate(0deg); /* IE 9 */
                        -moz-transform: rotate(0deg); /* Firefox */
                        -o-transform: rotate(0deg);
                      }
                      100% {
                        transform: rotate(360deg);
                        -ms-transform: rotate(360deg); /* IE 9 */
                        -moz-transform: rotate(360deg); /* Firefox */
                        -o-transform: rotate(360deg);
                      }
                    }

                    @-webkit-keyframes rotate {
                      0% {
                        -moz-transform: rotate(0deg);
                      }
                      100% {
                        -moz-transform: rotate(360deg);
                      }
                    }
                    .full {
                      cursor: pointer;
                      margin-right: 6px;
                    }
                  }
                }
                .image {
                  overflow: hidden;
                  flex: 1;
                  border-radius: 4px;
                }
              }
              .query {
                height: 100%;
                width: 100%;
                display: flex;
                flex-flow: column;
                border-radius: 4px;
                .setting {
                  font-size: 14px;
                  height: 100%;
                  display: flex;
                  flex-flow: column;
                  .name {
                    font-weight: bolder;
                    margin: 12px 10px 10px 10px;
                  }
                  .query-wrapper {
                    flex: 1;
                    text-align: left;
                    overflow: hidden;
                    .query-info {
                      display: flex;
                      flex-flow: wrap;
                      margin-left: 10px;
                      align-items: center;
                      padding-right: 10px;
                      height: 100%;
                    }
                  }
                  .more-setting {
                    display: none;
                    position: absolute;
                    right: 5px;
                    top: 1px;
                    .edit {
                      cursor: pointer;
                      margin-right: 6px;
                    }
                  }
                }
              }
              .rich,
              .view,
              .image {
                height: 100%;
                width: 100%;
                display: flex;
                flex-flow: column;
                border-radius: 4px;
                .setting {
                  font-size: 14px;
                  text-align: left;
                  height: 100%;
                  display: flex;
                  overflow: hidden;
                  .name {
                    position: absolute;
                    font-weight: bolder;
                    margin: 6px 10px 0 10px;
                  }
                  .image-info {
                    display: flex;
                    flex-flow: wrap;
                    width: 100%;
                    justify-content: center;
                    align-items: center;
                    background-repeat: no-repeat !important;
                    background-size: contain !important;
                    background-position: 50% 50% !important;
                    .no-drag {
                      width: 80%;
                      height: 80%;
                    }
                  }
                  .rich-info {
                    display: flex;
                    flex-flow: wrap;
                    width: 100%;
                    justify-content: center;
                    align-items: center;
                    .rich-field {
                      display: flex;
                      flex-flow: column;
                      ::v-deep p {
                        margin: 0;
                      }
                      ::v-deep {
                        ol {
                          padding-inline-start: 16px;
                        }
                        ol li {
                          list-style: decimal;
                        }
                        ul {
                          padding-inline-start: 16px;
                        }
                        ul li {
                          list-style: disc;
                        }
                      }
                    }
                  }
                  .view-info {
                    width: 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ::v-deep {
    .storyline-wrapper {
      margin: 10px 10px 0 10px;
      &:hover {
        border: none;
      }
    }
  }
}
</style>
